import { getItemMaker } from "./tools";

const i = getItemMaker("quest items");
export const questItems = [
  i("Crimson String"),
  i("Giftmas Box", "Quest92"),
  i("Summer Cooler"),
  i("Job Application", "JobApplication"),
  i("Sculpting Tools", "SmithingHammerChisel"),
  i("Guilding Tools"),
  i("Onyx Tools", "SmithingHammerChisel3"),
  i("BobJoePickle", "BobJoePickle"),
  i("BallJoePickle", "BallJoePickle"),
  i("BoneJoePickle"),
  i("Mining Certificate"),
  i("Broken Mic", "Quest16"),
  i("Loomi's Room Key", "Quest18"),
  i("Desert Topaz", "Crystal1"),
  i("Glacier Quartz", "Crystal2"),
  i("Galaxial Amethyst", "Crystal3"),
  i("Magma Geode"),
  i("Spirit Diamond"),
  i("Stone Peanut"),
  i("Ketchup Bottle", "Quest3"),
  i("Mustard Bottle", "Quest4"),
  i("Class Certificate"),
  i("Scouting Report"),
  i("Strange Rock", "Quest7"),
  i("Forest Villas Flyer Thingy", "Quest11"),
  i("Dog Bone", "Quest12"),
  i("Empty Box"),
  i("Employment Statistics", "Quest14"),
  i("Red Frisbee", "Quest15"),
  i("Golden Dubloon", "Quest19"),
  i("Signed Arrest Warrant"),
  i("Time Thingy", "Quest21"),
  i("Corporatube Sub", "Quest22"),
  i("Instablab Follower", "Quest23"),
  i("Cloudsound Follower", "Quest24"),
  i("Birthday Card", "Quest25"),
  i("Pre Crime Box"),
  i("Bag o Nuts", "Quest27"),
  i("Casual Confidante", "GoldricP1"),
  i("Triumphant Treason", "GoldricP2"),
  i("Claiming Cashe", "GoldricP3"),
  i("Bolt Cutters", "Cutter"),
  i("Monster Rating", "Quest32"),
  i("Player Rating With Letter P", "Quest33"),
  i("Player Rating With Letter S", "Quest34"),
  i("Flowies", "Quest41"),
  i("The Bobber Challenge Scroll", "Quest46"),
  i("Dootophone"),
  i("Damaged Cog", "Quest57"),
  i("Refurbished Cog", "Quest58"),
  i("Shuvelle's Vote", "Quest59"),
  i("Yondergreens Vote", "Quest60"),
  i("Bill Brr's Vote", "Quest61"),
  i("Signed Contract", "Quest62"),
  i("Blunderhills NPC Completion Token", "BadgeG1"),
  i("Blunder Skills Completion Token", "BadgeG2"),
  i("Blunderhills Misc Completion Token", "BadgeG3"),
  i("Yumyum Desert NPC Completion Token"),
  i("Yumyum Skills Completion Token"),
  i("Yumyum Misc Completion Token"),
  i("Easy Blunderhills NPC Token", "NPCtoken1"),
  i("Med Blunderhills NPC Token", "NPCtoken2"),
  i("Hard Blunderhills NPC Token", "NPCtoken3"),
  i("Woodsman Token", "NPCtoken5"),
  i("Glumlee Token", "NPCtoken6"),
  i("Stiltzcho Token", "NPCtoken4"),
  i("Funguy Token", "NPCtoken9"),
  i("Krunk Token", "NPCtoken10"),
  i("Tiki Chief Token", "NPCtoken11"),
  i("Dog Bone Token", "NPCtoken13"),
  i("Papua Piggea Token", "NPCtoken7"),
  i("Picnic Token", "Quest9"),
  i("TP Pete Token", "NPCtoken15"),
  i("Sproutinald Token", "NPCtoken12"),
  i("Dazey Token", "NPCtoken14"),
  i("Bandit Bob Token"),
  i("Snake Jar Token"),
  i("Whattso Token"),
  i("Cowbo Jones Token"),
  i("Carpetiem Token"),
  i("Goldric Token"),
  i("Cattleprod Token"),
  i("Fishpaste Token"),
  i("Loominadi Token"),
  i("Djonnut Token"),
  i("Scubidew Token"),
  i("Wellington Token"),
  i("Easy Yumyum Dez NPC Token"),
  i("Med Yumyum Dez NPC Token"),
  i("Hard Yumyum Dez NPC Token"),
  i("Lonely Hunter Token"),
  i("Hoggi Token"),
  i("Bellows Token"),
  i("Snouts Token"),
  i("Shuvelle Token", "NPCtoken35"),
  i("Yondergreen Token"),
  i("Bill Brr Token"),
  i("Crystalswine Token", "NPCtoken38"),
  i("Easy FB Tundra NPC Token"),
  i("Med FB Tundra NPC Token"),
  i("Hard FB Tundra NPC Token"),
  i("Tundra NPC Completion Token"),
  i("Tundra Skills Completion Token"),
  i("Tundra Misc Completion Token"),
  i("Sesame Seed", "Quest45"),
  i("Secret Map", "Quest87"),
  i("Blinding Lantern", "Quest90"),
  i("Elderly Peanut", "Quest47"),
  i("Pete the Peanut", "Quest48"),
  i("Worship Floppy Disc", "Quest93"),
  i("Bottled Wind", "Quest72"),
  i("Gaming Fertilizer", "Quest73"),
  i("Compost Bag", "Quest81"),
  i("Summoner Stone", "Quest82"),
  i("Sand of Time", "GemP30"),
];
